export default __webpack_public_path__ + "static/media/1-4.970263b7.jpg";